import React, { useEffect, useMemo, useState } from 'react';

import { makeStyles } from 'tss-react/mui';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';

import { prefixesFilterState } from '../../atoms/PrefixesFilterState';
import { warehouseState } from '../../atoms/WarehouseState';
import MultiSelect from '../../components/MultiSelect';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    marginTop: 30,
  },
}));

function Filter({ prefixes, regionsList, selectedRegions, selectedWarehouseIds }) {
  const [filterState, setFilterState] = useRecoilState(prefixesFilterState);
  const [warehouses, setWarehouses] = useRecoilState(warehouseState);
  const [selectRegions, setSelectRegions] = useState([]);
  const [selectWarehouses, setSelectWarehouses] = useState([]);

  const { classes } = useStyles();

  const warehouseOptions = useMemo(
    () =>
      warehouses?.items?.map((warehouse) => ({
        label: warehouse.alias ? `[${warehouse.id}] - ${warehouse.alias}` : `[${warehouse.id}]`,
        value: warehouse.id,
      })),
    [warehouses],
  );

  useEffect(() => {
    listFilter();
  }, [regionsList, warehouses]);

  useEffect(() => {
    const splitRegions = selectedRegions?.split(',');
    setSelectRegions(filterState.regionOptions?.filter((option) => splitRegions?.includes(option.value)));
  }, [filterState.regionOptions, selectedRegions]);

  useEffect(() => {
    const splitWarehouseIds = selectedWarehouseIds?.split(',');
    setSelectWarehouses(filterState.warehouseFilterOptions?.filter((option) => splitWarehouseIds?.includes(`${option.value}`)));
  }, [filterState.warehouseFilterOptions, selectedWarehouseIds]);

  const listFilter = () => {
    try {
      let regionsFilterOptions = [];

      if (regionsList?.length > 0) {
        regionsList.forEach((item) => {
          regionsFilterOptions.push({ label: item, value: item });
        });
        setFilterState({
          ...filterState,
          warehouseFilterOptions: warehouseOptions,
          regionOptions: regionsFilterOptions,
        });
      }
    } catch (err) {
      toast.error(err);
    }
  };

  const handleOnChangeRegion = (objs) => {
    setSelectRegions(objs);
    const selectedRegions = [];
    objs.map((region) => {
      selectedRegions.push(region.value);
    });

    setFilterState({
      ...filterState,
      selected: {
        ...filterState.selected,
        'regions[]': selectedRegions.join(','),
        page: 0,
      },
    });
  };

  const handleOnRemoveRegion = () => {
    setSelectRegions([]);
    setFilterState({
      ...filterState,
      selected: {
        ...filterState.selected,
        'regions[]': null,
        page: 0,
      },
    });
  };

  const handleOnChangeWarehouseId = (objs) => {
    setSelectWarehouses(objs);
    const selectedWarehouseId = [];

    objs.map((obj) => {
      selectedWarehouseId.push(obj.value);
    });

    setFilterState({
      ...filterState,
      selected: {
        ...filterState.selected,
        'warehouse_ids[]': selectedWarehouseId.join(','),
        page: 0,
      },
    });
  };

  const handleOnRemoveWarehouseId = () => {
    setSelectWarehouses([]);
    setFilterState({
      ...filterState,
      selected: {
        ...filterState.selected,
        'warehouse_ids[]': null,
        page: 0,
      },
    });
  };

  return (
    <div className={classes.root}>
      <MultiSelect
        label="Overview for"
        options={filterState.regionOptions || []}
        placeholder="all regions"
        onChange={handleOnChangeRegion}
        onRemove={handleOnRemoveRegion}
        selectedValues={selectRegions}
      />
      <MultiSelect
        label="and"
        options={filterState.warehouseFilterOptions || []}
        placeholder="all warehouses"
        onChange={handleOnChangeWarehouseId}
        onRemove={handleOnRemoveWarehouseId}
        selectedValues={selectWarehouses}
      />
    </div>
  );
}

export default Filter;
